var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "sidebar-profile", on: { click: _vm.select } },
    [
      !_vm.isCollapsed
        ? _c("h2", [
            _c("span", { class: [_vm.isCollapsed ? "sr-only" : ""] }, [
              _vm._v("\n\t\t\t" + _vm._s(_vm.student.NAME) + "\n\t\t")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "media text-sm" }, [
        _c("div", { class: [_vm.isCollapsed ? "media-full" : "media-left"] }, [
          _vm.$store.state.accessToken !== "" && !!_vm.student.STUDENT_RID
            ? _c("img", {
                staticClass: "media-object",
                attrs: { src: _vm.photoUrl, alt: _vm.student.STUDENT_ID }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { class: [_vm.isCollapsed ? "sr-only" : "media-body"] }, [
          _c(
            "ul",
            { staticClass: "list-unstyled" },
            _vm._l(_vm.student.ENROLLMENT, function(school, index) {
              return _c("li", { key: school.SCHOOL_ID + "_" + index }, [
                _c("strong", [_vm._v("Grade:")]),
                _vm._v(" " + _vm._s(school.GRADE_LEVEL) + "\n\t\t\t\t\t"),
                _c("br"),
                _vm._v(_vm._s(school.SCHOOL_TITLE) + "\n\t\t\t\t")
              ])
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }